/**
 * Encrypts details for secure URL sharing using browser-compatible methods
 */
export function encryptCandidateDetails(details: CandidateDetails): string {
  try {
    // For now, we'll just use base64 encoding/decoding
    // In a production environment, use proper encryption
    const jsonString = JSON.stringify(details);
    return btoa(encodeURIComponent(jsonString));
  } catch (error) {
    console.error('Error encrypting details:', error);
    return '';
  }
}

interface CandidateDetails {
  name?: string;
  email?: string;
  type?: 'registration' | 'invite';
  assessmentId?: string;
  candidateId?: string;
  assessmentDetails?: {
    title: string;
    skills: string[];
    organization: string;
  };
}

/**
 * Decrypts details from URL parameter
 */
export function decryptCandidateDetails(token: string): CandidateDetails | null {
  try {
    // For now, we'll just use base64 encoding/decoding
    // In a production environment, use proper encryption
    const decodedString = decodeURIComponent(atob(token));
    const details = JSON.parse(decodedString);
    
    // Validate the structure
    if (!details.type || !details.assessmentId) {
      throw new Error('Invalid token structure');
    }
    
    return details;
  } catch (error) {
    console.error('Error decrypting token:', error);
    return null;
  }
} 